export default {"src":"/_next/static/media/UserLogIconTjRed.1efc0122.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};